import type { Node } from 'react'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { Close } from 'app/assets/icons'

const { text } = colors

type Props = {
    titleNode?: Node,
    center?: boolean,
    closable?: boolean,
    handleClose?: Function,
    className?: string,
    color?: string
}

const ModalTitle = (props: Props) => {
    const {
        titleNode = null,
        center = false,
        closable = true,
        handleClose,
        className,
        color = text
    } = props
    return (
        <Fragment>
            {center ? (
                <Fragment>
                    {closable && (
                        <CloseButtonContainer
                            corner
                            onClick={handleClose}
                            className={className}>
                            <Close color={color} size={24} />
                        </CloseButtonContainer>
                    )}
                    {titleNode}
                </Fragment>
            ) : (
                <ModalTitleContainer>
                    {titleNode}
                    {closable && (
                        <CloseButtonContainer
                            onClick={handleClose}
                            className={className}>
                            <Close color={colors.text} size={24} />
                        </CloseButtonContainer>
                    )}
                </ModalTitleContainer>
            )}
        </Fragment>
    )
}

const ModalTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0;
    ${media.medium`
        margin: 0;
    `};
`

const CloseButtonContainer = styled.span`
    padding: 0;
    font-size: 0;
    cursor: pointer;
    ${props =>
        props.corner
            ? `
                position: relative; 
                left: calc(100% - 20px);
                top: 10px;
            `
            : ''};

    ${media.medium`
        ${props =>
            props.corner
                ? `
                top: -20px;
                left: 100%;
                &.coupons-modal,
                &.points-modal{
                    left: calc(100% - 20px);
                    top: 10px;
                }
                `
                : ''}
    `};
`

export { ModalTitle }
